import { APR, Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import axios from 'axios'
import Web3 from 'web3'

import aleswapVaultABI from '../abi/aleswapVault.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'

export const getAleswapVault = async (
  walletAddress: string,
  ct: Contract,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake[]> => {
  try {
    const { contractAddress, routerAddress } = ct
    const web3 = web3Prop || new Web3(getNodeUrl(56))
    const contract = new web3.eth.Contract(aleswapVaultABI as any, contractAddress)
    const balanceOf = await contract.methods.balanceOf(walletAddress).call()
    const getLpAddress = await contract.methods.want().call()
    const getLpStrategy = await contract.methods.strategy().call()
    const contractStrategy = new web3.eth.Contract(aleswapVaultABI as any, getLpStrategy)
    const getPoolId = await contractStrategy.methods.poolId().call()
    const balanceInfo = await calculate(
      web3,
      {
        lpAddress: getLpAddress,
        pool: getPoolId,
        availableBalanceOf: '0',
        balance: balanceOf
      },
      routerAddress,
      tokens,
      priceList
    )
    const result: Stake = {
      ...ct,
      ...balanceInfo
    }
    return [result]
  } catch (e) {
    console.log(e)
    return []
  }
}

interface vaultAleswapVault {
  apd: number
  apr: number
  apy: number
  farmName: string
  name: string
  pair: string
  pid: number
  pricePerShare: number
  token: string[]
  tradingApr: number
  tvl: number
}

interface responseAleswapVaultGetApr {
  timestamp: string
  tvl: number
  vaults: vaultAleswapVault[]
}

export const getAleswapVaultAPR = async (stakeTokenAddress: string): Promise<APR> => {
  try {
    const { data } = await axios.get<any, { data: responseAleswapVaultGetApr }>(`https://api.aleswap.finance/vaults`)
    const findAPR = data?.vaults.find((item) => item.pair === stakeTokenAddress)
    const getApy = findAPR?.apy || 0
    return {
      dailyAPR: (getApy * 1) / 100,
      weeklyAPR: (getApy * 7) / 100,
      monthlyAPR: (getApy * 30) / 100,
      yearlyAPR: getApy,
      yearAPY: getApy
    }
  } catch (err) {
    console.log('getAleswapVaultAPR', err)
    return null
  }
}
